import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import './style.scss';

const contractEngineSkeleton = () => {
  return (
    <div className={'contact-engine-skeleton'}>
      <div className={"liste"}>
      <Skeleton  variant="text" width={80} />
      <Skeleton  variant="text" width={80} />
      <Skeleton  variant="text" width={80} />
      <Skeleton  variant="text" width={80} />
      </div>
      <div className={"fleche"}>
      <Skeleton variant="rect" width={30} height={30}/>
      </div>
      <div className={"block1"}>
      <Skeleton variant="circle" width={50} height={50} />
      <Skeleton variant="text" width="80%" height={50}/>
      </div>
      <div className={"block2"}>
      <Skeleton variant="rect" width="100%" height={118}/>
      </div>
      <div className={"points"}>
      <Skeleton  variant="circle" width={15} />
      <Skeleton  variant="circle" width={15} />
      <Skeleton  variant="circle" width={15} />
      <Skeleton  variant="circle" width={15} />
      </div>

    </div>
  );
};
export default contractEngineSkeleton;